'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyles = undefined;

var _templateObject = _taggedTemplateLiteral([''], ['']);

exports.AreaCardComponent = AreaCardComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// TODO: Use @bd/bdcore-data/build/Builder/selectors :: getAreaRouteParams
function getAreaRouteParams(area) {
  return {
    communityMarketAreaMetro: (0, _lodash.get)(area, 'name'),
    communityMarketArea: (0, _lodash.get)(area, 'name')
  };
}

var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

function AreaCardComponent(_ref) {
  var area = _ref.area,
      areaRoute = _ref.areaRoute,
      arrowImage = _ref.arrowImage,
      backgroundImage = _ref.backgroundImage,
      button = _ref.button,
      className = _ref.className,
      countCommunitiesLabel = _ref.countCommunitiesLabel,
      countHomesLabel = _ref.countHomesLabel,
      countPlansLabel = _ref.countPlansLabel,
      getName = _ref.getName;

  var bgStyle = backgroundImage ? { backgroundImage: 'url(\'' + backgroundImage + '\')' } : undefined;

  return _react2.default.createElement(
    'div',
    { className: '' + className, key: (0, _lodash.get)(area, 'name') },
    _react2.default.createElement(
      'div',
      { className: 'AreaCard_wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'AreaCard_inner', style: bgStyle },
        _react2.default.createElement(
          _bdcoreNamedRoutes.Link,
          {
            name: areaRoute,
            params: getAreaRouteParams(area)
          },
          _react2.default.createElement(
            'div',
            { className: 'AreaCard_name' },
            getName(area)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'AreaCard_countWrapper' },
          area.communities && _react2.default.createElement(
            _bdcoreNamedRoutes.Link,
            {
              name: 'communities',
              className: 'AreaCard_count AreaCard_countCommunities',
              params: getAreaRouteParams(area)
            },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: 'AreaCard_countValue' },
                (0, _lodash.get)(area, 'communities', []).length
              ),
              ' ',
              _react2.default.createElement(
                'span',
                { className: 'AreaCard_countLabel' },
                countCommunitiesLabel
              )
            )
          ),
          area.homes && _react2.default.createElement(
            _bdcoreNamedRoutes.Link,
            {
              name: 'homes',
              className: 'AreaCard_count AreaCard_countHomes',
              params: getAreaRouteParams(area)
            },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: 'AreaCard_countValue' },
                (0, _lodash.get)(area, 'homes', []).length
              ),
              ' ',
              _react2.default.createElement(
                'span',
                { className: 'AreaCard_countLabel' },
                countHomesLabel
              )
            )
          ),
          area.plans && _react2.default.createElement(
            _bdcoreNamedRoutes.Link,
            {
              name: 'plans',
              className: 'AreaCard_count AreaCard_countPlans',
              params: getAreaRouteParams(area)
            },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: 'AreaCard_countValue' },
                (0, _lodash.get)(area, 'plans', []).length
              ),
              ' ',
              _react2.default.createElement(
                'span',
                { className: 'AreaCard_countLabel' },
                countPlansLabel
              )
            )
          )
        ),
        !button && arrowImage && _react2.default.createElement(
          _bdcoreNamedRoutes.Link,
          { className: 'AreaCard_arrowIcon', name: areaRoute, params: getAreaRouteParams(area) },
          _react2.default.createElement('img', { src: arrowImage, alt: 'Go To Communities Button' })
        ),
        button && _react2.default.createElement(
          _bdcoreNamedRoutes.Link,
          { className: 'AreaCard_arrowIcon', name: areaRoute, params: getAreaRouteParams(area) },
          typeof button === 'function' ? button(area) : button
        )
      )
    )
  );
}

AreaCardComponent.propTypes = {
  /** Buildercloud Area Object */
  area: _propTypes2.default.object.isRequired,
  /** Main Area Route Name */
  areaRoute: _propTypes2.default.string,
  /** Arrow Image */
  arrowImage: _propTypes2.default.string,
  /** Background Image URL applied AreaCard_inner */
  backgroundImage: _propTypes2.default.string,
  button: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.shape({
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired,
    route: _propTypes2.default.string,
    path: _propTypes2.default.string
  })]),
  className: _propTypes2.default.string,
  /** Community count label */
  countCommunitiesLabel: _propTypes2.default.string,
  /** Home count label */
  countHomesLabel: _propTypes2.default.string,
  /** Plan count label */
  countPlansLabel: _propTypes2.default.string,
  /** Function to display area name. Allows JSX */
  getName: _propTypes2.default.func
};

AreaCardComponent.defaultProps = {
  areaRoute: 'communities',
  arrowImage: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAAJUlEQVR42mNgAILy8vL/DLgASBKnApgkVgXIkhgKiNKJ005s4gDLbCZBiSxfygAAAABJRU5ErkJggg==',
  backgroundImage: undefined,
  button: undefined,
  className: '',
  countCommunitiesLabel: 'Communities',
  countHomesLabel: 'Homes',
  countPlansLabel: 'Plans',
  getName: function getName(area) {
    return _react2.default.createElement(
      'span',
      null,
      area.name
    );
  }
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(AreaCardComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-areacard/build/AreaCard.js
// module id = 1193
// module chunks = 0